import Strings from "./strings";
import Synchronization from "./synchronize";
import Annotation from "./annotation";

const Constants = {
  Strings,
  Synchronization,
  Annotation,
};

export default Constants;
